import { render, staticRenderFns } from "./foodmore.vue?vue&type=template&id=174ce2f0&scoped=true"
import script from "./foodmore.vue?vue&type=script&lang=js"
export * from "./foodmore.vue?vue&type=script&lang=js"
import style0 from "./foodmore.vue?vue&type=style&index=0&id=174ce2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174ce2f0",
  null
  
)

export default component.exports